
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"transform":"matrix(.73106 .68232 -.73106 .68232 0 1)","stroke":"#1565C0","stroke-width":"2","stroke-linecap":"round","d":"M1-1h17.15"}}),_c('path',{attrs:{"d":"M14 1L1.462 12.702","stroke":"#1565C0","stroke-width":"2","stroke-linecap":"round"}})])
          )
        }
      }
    